import { QueryResult } from 'react-query';
// eslint-disable-next-line import/no-cycle
import { Kunde } from './kunde';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';

export type ZusatzadresseTyp = 'L' | 'R';

export interface Zusatzadresse {
    nr: number;
    kNr: number;
    typ: ZusatzadresseTyp;
    std: boolean;
    name1: string;
    name2: string;
    strasse: string;
    plz: string;
    ort: string;
    land: string;
    archiv: boolean;
    combinedValues: string;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
    kunde?: Kunde;
}

export const defaultZusatzadresse: Zusatzadresse = {
    kNr: 0,
    nr: 0,
    typ: 'L',
    std: false,
    name1: '',
    name2: '',
    strasse: '',
    plz: '',
    ort: '',
    land: '',
    archiv: false,
    combinedValues: '',
};

export interface ZusatzadresseFilter {
    nr?: number;
    kNr?: number;
    typ?: string;
    includeArchiv?: boolean;
    withKunde?: boolean;
    maxRows?: number;
}

export function useZusatzadresseList(
    filter: ZusatzadresseFilter,
    apiOptions?: UseApiOptions<Zusatzadresse[]>,
): QueryResult<Zusatzadresse[]> {
    return useApi<Zusatzadresse[]>(Controller.zusatzadresse + '/list', { filter }, apiOptions);
}

export async function addZusatzadresse(zusatzadresse: Zusatzadresse): Promise<void> {
    return callApi<void>(Controller.zusatzadresse + '/add', { zusatzadresse });
}

export async function updateZusatzadresse(zusatzadresse: Zusatzadresse): Promise<void> {
    return callApi<void>(Controller.zusatzadresse + '/update', { zusatzadresse });
}
